var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe1675(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 106,
    viewBox: "0 0 97 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1675",
    "data-name": "Groupe 1675",
    transform: "translate(-8588 -1461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    d: "M0,0H97a0,0,0,0,1,0,0V57.5A48.5,48.5,0,0,1,48.5,106h0A48.5,48.5,0,0,1,0,57.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(8588 1461)",
    fill: "#f3f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_repeat",
    "data-name": "vuesax/linear/repeat",
    transform: "translate(8062.202 987.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "repeat",
    transform: "translate(556 508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.459 3.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H21.1a4.568,4.568,0,0,1,4.574,4.574V9.637",
    transform: "translate(0 4.818)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.818,0,0,4.818,4.818,9.637",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M25.678,9.637H4.574A4.568,4.568,0,0,1,0,5.062V0",
    transform: "translate(0 16.041)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,9.637,4.818,4.818,0,0",
    transform: "translate(20.86 20.86)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H36.6V36.6H0Z",
    transform: "translate(36.596 36.596) rotate(180)",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe1675);
export default __webpack_public_path__ + "static/media/Groupe-1675.bc60c2e4372f0fb61d27543675aa5faf.svg";
export { ForwardRef as ReactComponent };